import { yupResolver } from '@hookform/resolvers/yup';
import { Box } from '@material-ui/core';
import { Grid } from '@mui/material';
import classNames from 'classnames';
import { SGSForm, SGSFormDate, SGSFormInput, SGSFormLayout, SGSRadioCtr } from 'components';
import SGSCheckboxCtr from 'components/SGSCheckboxCtr';
import SGSInputIncrement from 'components/SGSIncrementInput';
import SGSSelectCtr from 'components/SGSSelectCtrl';
import { useArretTravailFormContext } from 'features/arretTravail/contexts/ArretTravailFormProvider';
import useValidationEffects from 'features/arretTravail/hooks/useValidationEffects';
import { categoryOptions, cspOptions, genderOptions, optionNationality, regimeOptions, situationFamilleOptions } from 'features/arretTravail/models/affilie/index';
import { hasSuspension } from 'features/arretTravail/models/businessRules/SuspensionRules';
import { CodeCerfa, getScenarioAtByCodes } from 'features/arretTravail/models/scenarii';
import React from 'react';
import { FormProvider, SubmitHandler, useForm } from 'react-hook-form';
import styles from '../../../css/ArretTravail.module.scss';
import { useAffilieSchema } from './schema';

type Props = {
    store: any;
    onSubmit: SubmitHandler<AffilieSchema>;
    actions?: JSX.Element;
};

type AffilieSchema = {
    affilie: {
        gender: string;
        lastname: string;
        firstname: string;
        birthDate: Date;
        registrationNumber?: string;
        SSNumber: string;
        SSkey: string;
        regimeCod: string;
        famillyStatusCod: string;
        childNbr: string;
        nationalityCod?: string;
        email?: string;
        phone?: string;
        address?: string;
        addressCplt?: string;
        postalCode?: string;
        city?: string;
        qualification?: string;
        hireDate?: string;
        statusCod?: string;
        coefHierarchi?: string;
        tpa?: boolean;
        vrp?: boolean;
        job: {
            partimeEmployee?: boolean; // TODO :: refactor
        };
    };
};

const FormAffilie: React.FC<Props> = ({ onSubmit, store, actions }) => {
    const { activeStep, setStepFailed } = useArretTravailFormContext();
    const displayNationality = getScenarioAtByCodes(store)?.cerfa === CodeCerfa.S6202;
    const hasContact = false;
    const hasPartimeEmployee = false;

    const validationSchema = useAffilieSchema({ store, hasContact });

    const methods = useForm<AffilieSchema>({
        resolver: yupResolver(validationSchema),
        defaultValues: store,
    });

    const {
        handleSubmit,
        formState: { errors },
        control,
    } = methods;

    useValidationEffects({ errors, activeStep, setStepFailed, control });

    const displayTpa = hasSuspension(store);

    console.log(errors);

    return (
        <FormProvider {...methods}>
            <SGSFormLayout onSubmit={handleSubmit(onSubmit)} actions={actions}>
                <Grid container justifyContent="center">
                    <Grid item xs={12} md={6}>
                        <Box className={styles.title}>Profil :</Box>
                        <SGSForm.Row>
                            <SGSForm.Col>
                                <SGSRadioCtr row options={genderOptions} name="affilie.gender" className="mb-n3" />
                            </SGSForm.Col>
                        </SGSForm.Row>
                        <SGSForm.Row>
                            <SGSForm.Col md={6}>
                                <SGSFormInput variant="outlined" name="affilie.lastname" label="workStop.fields.affilie.lastname" />
                            </SGSForm.Col>
                            <SGSForm.Col md={6}>
                                <SGSFormInput variant="outlined" name="affilie.firstname" label="workStop.fields.affilie.firstname" />
                            </SGSForm.Col>
                        </SGSForm.Row>
                        <SGSForm.Row>
                            <SGSForm.Col md={6}>
                                <SGSFormDate inputVariant="outlined" name="affilie.birthDate" label="workStop.fields.affilie.birthDate" />
                            </SGSForm.Col>
                            <SGSForm.Col md={6}>
                                <SGSFormInput variant="outlined" name="affilie.registrationNumber" label="workStop.fields.affilie.registrationNumber" />
                            </SGSForm.Col>
                        </SGSForm.Row>
                        <SGSForm.Row>
                            <SGSForm.Col md={5}>
                                <SGSFormInput variant="outlined" name="affilie.SSNumber" label="workStop.fields.affilie.SSNumber" />
                            </SGSForm.Col>
                            <SGSForm.Col md={2}>
                                <SGSFormInput variant="outlined" name="affilie.SSkey" label="workStop.fields.affilie.SSkey" />
                            </SGSForm.Col>
                            <SGSForm.Col md={5}>
                                <SGSRadioCtr row options={regimeOptions} name="affilie.regimeCod" label="workStop.fields.affilie.regimeCod" className="mb-n3" />
                            </SGSForm.Col>
                        </SGSForm.Row>
                        <SGSForm.Row>
                            <SGSForm.Col md={5}>
                                <SGSInputIncrement name="affilie.childNbr" label="workStop.fields.affilie.childNbr" />
                            </SGSForm.Col>
                            {displayNationality && (
                                <SGSForm.Col md={6}>
                                    <SGSSelectCtr name="affilie.nationalityCod" options={optionNationality} variant="outlined" label="workStop.fields.affilie.nationalityCod" />
                                </SGSForm.Col>
                            )}
                        </SGSForm.Row>
                        <SGSForm.Row>
                            <SGSForm.Col md={12}>
                                <SGSRadioCtr row options={situationFamilleOptions} name="affilie.famillyStatusCod" label="workStop.fields.affilie.famillyStatusCod" className="mb-n3" />
                            </SGSForm.Col>
                        </SGSForm.Row>
                        {hasContact && (
                            <>
                                <Box className={classNames(styles.title, 'mt-4 mb-4')}>CONTACT :</Box>
                                <SGSForm.Row>
                                    <SGSForm.Col md={6}>
                                        <SGSFormInput variant="outlined" name="affilie.email" label="workStop.fields.affilie.email" />
                                    </SGSForm.Col>
                                    <SGSForm.Col md={6}>
                                        <SGSFormInput variant="outlined" name="affilie.phone" label="workStop.fields.affilie.phone" />
                                    </SGSForm.Col>
                                </SGSForm.Row>
                            </>
                        )}
                        <Box className={classNames(styles.title, 'mt-4  mb-4')}>ADRESSE :</Box>
                        <SGSForm.Row>
                            <SGSForm.Col md={12}>
                                <SGSFormInput variant="outlined" name="affilie.address" label="workStop.fields.affilie.address" />
                            </SGSForm.Col>
                        </SGSForm.Row>
                        <SGSForm.Row>
                            <SGSForm.Col md={12}>
                                <SGSFormInput variant="outlined" name="affilie.addressCplt" label="workStop.fields.affilie.addressCplt" />
                            </SGSForm.Col>
                        </SGSForm.Row>
                        <SGSForm.Row>
                            <SGSForm.Col md={6}>
                                <SGSFormInput variant="outlined" name="affilie.postalCode" label="workStop.fields.affilie.postalCode" />
                            </SGSForm.Col>
                            <SGSForm.Col md={6}>
                                <SGSFormInput variant="outlined" name="affilie.city" label="workStop.fields.affilie.city" />
                            </SGSForm.Col>
                        </SGSForm.Row>
                        <Box className={classNames(styles.title, 'mt-4  mb-4')}>EMPLOI :</Box>
                        <SGSForm.Row>
                            <SGSForm.Col>
                                <SGSSelectCtr name="affilie.qualificationCod" options={cspOptions} variant="outlined" label="workStop.fields.affilie.qualification" />
                            </SGSForm.Col>
                        </SGSForm.Row>
                        <SGSForm.Row>
                            <SGSForm.Col md={6}>
                                <SGSFormDate inputVariant="outlined" name="affilie.hireDate" label="workStop.fields.affilie.hireDate" />
                            </SGSForm.Col>
                            <SGSForm.Col md={6}>
                                <SGSRadioCtr row options={categoryOptions} name="affilie.statusCod" label="workStop.fields.affilie.status" className="mb-n3" />
                            </SGSForm.Col>
                        </SGSForm.Row>
                        <SGSForm.Row>
                            <SGSForm.Col md={6}>
                                <SGSFormInput variant="outlined" name="affilie.coefHierarchi" label="workStop.fields.affilie.coefHierarchi" />
                            </SGSForm.Col>
                        </SGSForm.Row>
                        <SGSForm.Row>
                            {displayTpa && (
                                <SGSForm.Col md={12}>
                                    <SGSCheckboxCtr name="affilie.tpa" label="* Salarié en temps partiel annualisé (temps partiel aménagé sur tout ou partie de l’année)" />
                                </SGSForm.Col>
                            )}
                        </SGSForm.Row>
                        <SGSForm.Row>
                            {hasPartimeEmployee && (
                                <SGSForm.Col md={6}>
                                    <SGSCheckboxCtr name="affilie.job.partimeEmployee" label="workStop.fields.affilie.job.partimeEmployee"></SGSCheckboxCtr>
                                </SGSForm.Col>
                            )}
                            <SGSForm.Col md={6}>
                                <SGSCheckboxCtr name="affilie.vrp" label="workStop.fields.affilie.vrp"></SGSCheckboxCtr>
                            </SGSForm.Col>
                        </SGSForm.Row>
                    </Grid>
                </Grid>
            </SGSFormLayout>
        </FormProvider>
    );
};

export default FormAffilie;
